var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeeWhatMatters(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06153 17.6528C7.97819 17.8774 7.97819 18.1243 8.06153 18.3488C8.87323 20.317 10.251 21.9998 12.0203 23.184C13.7896 24.3681 15.8706 25.0002 17.9995 25.0002C20.1285 25.0002 22.2095 24.3681 23.9788 23.184C25.748 21.9998 27.1258 20.317 27.9375 18.3488C28.0209 18.1243 28.0209 17.8774 27.9375 17.6528C27.1258 15.6847 25.748 14.0019 23.9788 12.8177C22.2095 11.6336 20.1285 11.0015 17.9995 11.0015C15.8706 11.0015 13.7896 11.6336 12.0203 12.8177C10.251 14.0019 8.87323 15.6847 8.06153 17.6528Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeWhatMatters);
export default __webpack_public_path__ + "static/media/seeWhatMatters.b69e84d579c095d815ad92a332d61ac1.svg";
export { ForwardRef as ReactComponent };